export const MAIN_SECTION = 'main';

export const DETAILS_SECTION = 'details';

export const ORDER_PAYMENT_LIST_EXPORT_ID = 'order-payment-c';

export const ORDER_PAYMENT_LIST_TITLE = 'Listado de pagos';

export const MAIN_SECTION_LOCALIZED_PROPERTIES = {
  trip: 'Viaje',
  route: 'Ruta',
  user: 'Usuario',
  date: 'Fecha',
  serial: 'Cantidad Documentos',
  totalPayingAmount: 'Recaudado',
  totalPayingRealAmount: 'Pago Aceptado',
  totalPaymentReviewCountSend: 'Pago Rechazado',
  amountNotVerified: 'Pago sin verificar',
  paymentReviewPercentage: '% Revision',
  paymentReviewPercentageERP:  '% Envio'
};

export const DETAILS_SECTION_LOCALIZED_PROPERTIES = {
route:'Ruta',
user:'Usuario',
shipToName:'Socio de Negocio',
bank: 'Banco',
accountNumber:'Nro Cuenta Banco',
serials:'Nro. Documento Pago',
documentType: 'Tipo Documento',
document:'Nro. Documento',
dateHour:'Fecha',
paymentType:'Tipo Pago',
paying:'Abono',
operationNumber:'Nro. Operacion',
paymentReview:'Estado',
comment:'Comentario'
};
